import { AppBar, IconButton, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MenuIcon } from 'components/icons/MenuIcon';
import { HEADER } from 'config';

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
}));

type Props = {
  onOpenSidebar: VoidFunction;
};

export default function DashboardHeader({ onOpenSidebar }: Props) {
  return (
    <RootStyle>
      <Toolbar sx={{ minHeight: '100% !important' }}>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </RootStyle>
  );
}
